import {
  jb_moment_teaser_item_css_default
} from "./chunk.S2V4TYID.js";
import {
  Linkable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.LK5OUX7S.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n,
  r as r2
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-moment-teaser-item/jb-moment-teaser-item.ts
var JbMomentTeaserItem = class extends Linkable(r) {
  constructor() {
    super(...arguments);
    this._hovering = false;
  }
  _hoverLinkIn() {
    this._hovering = true;
  }
  _hoverLinkOut() {
    this._hovering = false;
  }
  _tracking(e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "image-page-teaser"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`<a
      @jb-link:clicked=${this._tracking}
      @mouseout=${this._hoverLinkOut}
      @mouseover=${this._hoverLinkIn}
      @blur=${this._hoverLinkOut}
      @focus=${this._hoverLinkIn}
      data-linkable
    >
      ${this.image ? ke`<jb-picture
            .alt=${this.button?.text}
            .imgData=${this.image.imgData}
            aspect="aspect_21by9"
            fit="cover"
            ?lazy=${this.image.lazy}
          ></jb-picture>` : D}
      <div class="content">
        <h3>${this.headline}</h3>
        <div class="buttons">
          ${this.button ? ke`
                <jb-button-tertiary
                  .forceHover=${this._hovering}
                  .text=${this.button.text}
                  tabindex="-1"
                ></jb-button-tertiary>
              ` : D}
        </div>
      </div>
    </a>`;
  }
};
JbMomentTeaserItem.styles = jb_moment_teaser_item_css_default;
__decorateClass([
  n({ type: Object })
], JbMomentTeaserItem.prototype, "button", 2);
__decorateClass([
  n()
], JbMomentTeaserItem.prototype, "headline", 2);
__decorateClass([
  n({ type: Object })
], JbMomentTeaserItem.prototype, "image", 2);
__decorateClass([
  n({ type: Boolean })
], JbMomentTeaserItem.prototype, "randomized", 2);
__decorateClass([
  r2()
], JbMomentTeaserItem.prototype, "_hovering", 2);
JbMomentTeaserItem = __decorateClass([
  customElement("jb-moment-teaser-item")
], JbMomentTeaserItem);

export {
  JbMomentTeaserItem
};
